export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterPackages.vue?vue&type=template&id=09d409aa&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/SinisterPackages.vue?vue&type=template&id=09d409aa&scoped=true
// module id = 2068
// module chunks = 31